module.exports = __webpack_public_path__ + "static/img/2.5a6edbd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/eng/2.png
// module id = 8SDD
// module chunks = 0